module.exports = __webpack_public_path__ + "static/img/product_detail2.853f3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_detail2.jpg
// module id = QZi5
// module chunks = 16